import React from 'react'
import styles from './index.module.scss'

export default function RescueHome (){
  return  (
    <div>
      <h1 className={styles.title}>在线救援详情页</h1>
    </div>
  )
}